import { useLearningOpportunityOptionsQuery } from './use-learning-opportunity-options-query';

export const useLearningOpportunityPermissions = (
    learningOpportunityId: string,
): {
    readonly canUserDeleteLearningOpportunity: boolean;
    readonly canUserEditLearningOpportunity: boolean;
    readonly isPending: boolean;
} => {
    const { data: options, isPending } = useLearningOpportunityOptionsQuery(learningOpportunityId);

    const canUserEditLearningOpportunity = options?.canEditLearningOpportunity ?? false;
    const canUserDeleteLearningOpportunity = options?.canDeleteLearningOpportunity ?? false;

    return { canUserDeleteLearningOpportunity, canUserEditLearningOpportunity, isPending };
};
